<div class="image-config">
  <!-- <div style="border-bottom: 1px solid rgba(141, 141, 141, 1); color: rgba(68, 68, 68, 1); width: 600px;" class="d-flex justify-content-between px-3 pb-2 align-items-center mb-3">
    <div class="font-weight-bold">
      {{'enterprise_contract.image_signing.registered_tab.no_image.preview_signature' | translate}}
    </div>
    <button style="margin-left:1rem;" mat-icon-button color="primary" (click)="onOpenDialog(ConfigImageDialog)">
      <mat-icon>border_color</mat-icon>
    </button>
  </div> -->

  <div class="image-config_preview" [style.width]="setSizeFrameImage().width" [style.height]="setSizeFrameImage().height">
   <div class="image-config_scale" id="image-config_scale">
      <ng-content></ng-content>
   </div>
  </div>

  <button type="button" class="m-left-1 css-iphone" mat-icon-button color="primary" (click)="onOpenDialog(ConfigImageDialog)">
    <mat-icon>border_color</mat-icon>
    <span>{{ 'button.short_edit' | translate }}</span>
  </button>
</div>

<ng-container *ngIf="!(userType == '3' || userType == '4' || userType == '5' || isHiddenLabel)">
  <div style="font-style: italic" class="text-center">
    {{'enterprise_contract.image_signing.registered_tab.no_image.guiding' | translate}}
  </div>
</ng-container>


<ng-template #ConfigImageDialog>
  <h2 mat-dialog-title>
    {{ "title.config_system_image" | translate }}
    <button type="button" class="close" aria-label="Close" (click)="onCloseDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>

  <mat-divider></mat-divider>
  <div class="image-config_container">
    <div class="image-config_form mt-3">
      <ng-container *ngTemplateOutlet="ConfigForm"></ng-container>
      <div [hidden]="!signConfigClone.signatureImage.enabled">
        <ng-container  *ngTemplateOutlet="ConfigImageForm"></ng-container>
      </div>
    </div>
    <div class="image-config_form mt-3">
      <div class="image-config_form">
        <ng-container *ngTemplateOutlet="ConfigSignForm"></ng-container>
      </div>
      <div class="image-config_view">
        <ng-container *ngTemplateOutlet="ImageConfigView"></ng-container>
      </div>
    </div>

  </div>

  <mat-divider></mat-divider>
  <mat-dialog-actions align="center" class="mt-2">
    <button mat-stroked-button color="primary" class="mr-3" type="button" (click)="onCloseDialog()">
      <svg style="margin-right: 0.5rem" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6231_1775)">
          <rect x="0.487061" y="0.620972" width="20" height="20" rx="10" fill="#EE0033"/>
          <path d="M16.3204 5.96264L15.1454 4.78764L10.4871 9.44597L5.82875 4.78764L4.65375 5.96264L9.31208 10.621L4.65375 15.2793L5.82875 16.4543L10.4871 11.796L15.1454 16.4543L16.3204 15.2793L11.6621 10.621L16.3204 5.96264Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_6231_1775">
            <rect x="0.487061" y="0.620972" width="20" height="20" rx="10" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      {{ "button.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" type="submit" (click)="confirm()" [disabled]="disableConfirmBtn()">
      <!-- <svg style="margin-right: 0.5rem" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.1454 0.612638C12.8287 0.295972 12.4037 0.120972 11.9621 0.120972H2.65373C1.72873 0.120972 0.987061 0.870972 0.987061 1.78764V13.4543C0.987061 14.371 1.73706 15.121 2.65373 15.121H14.3204C15.2371 15.121 15.9871 14.371 15.9871 13.4543V4.14597C15.9871 3.7043 15.8121 3.2793 15.4954 2.97097L13.1454 0.612638ZM8.48706 13.4543C7.10373 13.4543 5.98706 12.3376 5.98706 10.9543C5.98706 9.57097 7.10373 8.4543 8.48706 8.4543C9.87039 8.4543 10.9871 9.57097 10.9871 10.9543C10.9871 12.3376 9.87039 13.4543 8.48706 13.4543ZM9.32039 5.12097H4.32039C3.40373 5.12097 2.65373 4.37097 2.65373 3.4543C2.65373 2.53764 3.40373 1.78764 4.32039 1.78764H9.32039C10.2371 1.78764 10.9871 2.53764 10.9871 3.4543C10.9871 4.37097 10.2371 5.12097 9.32039 5.12097Z" fill="white"/>
      </svg> -->
      {{ "digital-certificate-default.dialog_add.done" | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #ConfigForm>
  <h5>{{"enterprise_contract.image_signing.no_image.config_sign_image" | translate}}</h5>
  <small *ngIf="allValid(signConfigClone) === 'non-check'" style="color: #ee0033;">{{
    "enterprise_contract.image_signing.no_image.select_least_one_config" | translate}}</small>
  <mat-divider></mat-divider>
  <div class="config-form-item group mt-3">
    <mat-checkbox [disabled]="isCheckboxLocked('enterpriseName')" (ngModelChange)="onCheckboxChange()" [(ngModel)]="signConfigClone.enterpriseName.enabled">
      {{'enterprise_contract.image_signing.no_image.subject_name' | translate}}  <span *ngIf="required('enterpriseName')" class="text-danger">*</span>
    </mat-checkbox>
    <mat-checkbox *ngIf="showConfigPhone()" [disabled]="isCheckboxLocked('phoneNumber')" (ngModelChange)="onCheckboxChange()"
      [(ngModel)]="signConfigClone.phoneNumber.enabled">
      {{'enterprise_contract.image_signing.no_image.phone_number' | translate}} <span *ngIf="required('phoneNumber')" class="text-danger">*</span>
    </mat-checkbox>
  </div>

  <div class="config-form-item">
    <mat-checkbox [disabled]="isCheckboxLocked('signingTime')" (ngModelChange)="onCheckboxChange()" [(ngModel)]="signConfigClone.signingTime.enabled">
      <div [innerHTML]="required('signingTime') ? formatCodeHTML() :('enterprise_contract.image_signing.no_image.signing_time_1' | translate)"></div>
    </mat-checkbox>
  </div>
  <div class="config-form-item form input-config">
    <mat-checkbox [disabled]="isCheckboxLocked('address')" (ngModelChange)="onCheckboxChange($event ? addressInput : null)" style="display: inline-block;"
                  [(ngModel)]="signConfigClone.address.enabled" class="w-100" style="display: flex;">
      <mat-label style="width: 16%;min-width: 70px;white-space: nowrap;">{{'enterprise_contract.image_signing.no_image.address' | translate}} <span *ngIf="required('address')" class="text-danger">*</span>: </mat-label>
      <mat-form-field appearance="fill">
        <input #address="ngModel" #addressInput [(ngModel)]="signConfigClone.address.value"
               [required]="signConfigClone.address.enabled" matInput maxlength="100"
               placeholder="{{'enterprise_contract.image_signing.no_image.address' | translate}}" type="text"
               (blur)="updateView()"
               (focusout)="signConfigClone.address.value = signConfigClone.address.value.trim()"
               [readonly]="isCheckboxLocked('address') && !signConfigClone.address.enabled"
        >
        <mat-error *ngIf="address.invalid && address.errors['required']" class="control-error">
          {{'enterprise_contract.image_signing.no_image.address_required' | translate}}
        </mat-error>
      </mat-form-field>
    </mat-checkbox>
  </div>

  <div class="config-form-item">
    <mat-checkbox [disabled]="isCheckboxLocked('greenTick')" (ngModelChange)="onCheckboxChange()" [(ngModel)]="signConfigClone.greenTick.enabled">
      {{'enterprise_contract.image_signing.no_image.green_tick' | translate}} <span *ngIf="required('greenTick')" class="text-danger">*</span>
    </mat-checkbox>
  </div>
  <div class="config-form-item form input-config">
    <mat-checkbox [disabled]="isCheckboxLocked('position')" (ngModelChange)="onCheckboxChange($event ? positionInput : null)" style="display: inline-block;"
      [(ngModel)]="signConfigClone.position.enabled" class="w-100">
      <mat-label style="width: 16%;min-width: 70px;white-space: nowrap;">{{'enterprise_contract.image_signing.no_image.position' | translate}} <span *ngIf="required('position')" class="text-danger">*</span>: </mat-label>
      <mat-form-field appearance="fill">
        <input #position="ngModel" #positionInput [(ngModel)]="signConfigClone.position.value"
          [required]="signConfigClone.position.enabled" matInput maxlength="50"
          placeholder="{{'enterprise_contract.image_signing.no_image.input_position' | translate}}" type="text"
          (blur)="updateView()"
          (focusout)="signConfigClone.position.value = signConfigClone.position.value.trim()"
          [readonly]="isCheckboxLocked('position') && !signConfigClone.position.enabled"
          >
        <mat-error *ngIf="position.invalid && position.errors['required']" class="control-error">
          {{'enterprise_contract.image_signing.no_image.position_required' | translate}}
        </mat-error>
      </mat-form-field>
    </mat-checkbox>
  </div>
  <div class="config-form-item">
    <mat-checkbox [disabled]="isCheckboxLocked('signatureImage')" (ngModelChange)="onCheckboxSignatureImageChange()" [(ngModel)]="signConfigClone.signatureImage.enabled">
      {{'enterprise_contract.image_signing.no_image.signatureImage' | translate}} <span *ngIf="required('signatureImage')" class="text-danger">*</span>
    </mat-checkbox>
  </div>

<!--  checkbox email-->
  <div class="config-form-item">
    <mat-checkbox [disabled]="isCheckboxLocked('email')" [ngModel]="signConfigClone.email.enabled" (ngModelChange)="onEmailCheckboxChange($event)">
      Email <span *ngIf="required('email')" class="text-danger">*</span>
    </mat-checkbox>
  </div>
</ng-template>

<ng-template #ConfigSignForm >
  <div>
    <h5>{{"enterprise_contract.image_signing.no_image.preview_sign_image" | translate}}</h5>
    <mat-divider></mat-divider>
    <div class="row" style="margin: unset!important;">
      <div class="col-10 pl-0 pr-3">
        <mat-form-field style="line-height: 1.5" class="w-100 mt-3">
          <mat-label>{{'enterprise_contract.image_signing.no_image.contentPosition' | translate}}</mat-label>
          <mat-select (selectionChange)="onCheckboxChange()" [(ngModel)]="signConfigClone.contentPosition.value">
            <mat-option *ngFor="let item of contentPosition;let i = index" [value]="item.value">
              <span>{{ item.name | translate }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-2 pr-0 d-flex align-items-center justify-content-end">
        <div class="d-flex align-item-center justify-content-center">
          <mat-button-toggle-group name="ingredients" aria-label="Ingredients"
                                   multiple>
            <mat-button-toggle (click)="selectFontWeight()" [ngStyle]="{ 'background-color': signConfigClone.fontWeight.value ? '#e0e0e0' : 'white'  }" value="bold"><mat-icon> format_bold</mat-icon></mat-button-toggle>
            <mat-button-toggle (click)="selectFontStyle()" [ngStyle]="{ 'background-color': signConfigClone.fontStyle.value ? '#e0e0e0' : 'white'  }" value="italic"><mat-icon> format_italic</mat-icon></mat-button-toggle>
          </mat-button-toggle-group>
        </div>
<!--        <div (click)="selectFontStyle()" style="cursor: pointer" class="mr-2">-->
<!--          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <rect y="0.620972" width="24" height="24" rx="5" fill="#EE0033"/>-->
<!--            <path d="M6 15.621V18.621H14V15.621H11.79L15.21 7.62097H18V4.62097H10V7.62097H12.21L8.79 15.621H6Z" fill="white"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <div (click)="selectFontWeight()"  style="cursor: pointer; margin-top: -0.25rem">-->
<!--          <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path d="M10.25 4.62097C10.25 2.36097 8.5 0.620972 6.25 0.620972H0V14.621H7.04C9.13 14.621 10.75 12.921 10.75 10.831C10.75 9.31097 9.89 8.01097 8.6 7.41097C9.57 6.74097 10.25 5.64097 10.25 4.62097ZM3 3.12097H6C6.83 3.12097 7.5 3.79097 7.5 4.62097C7.5 5.45097 6.83 6.12097 6 6.12097H3V3.12097ZM6.5 12.121H3V9.12097H6.5C7.33 9.12097 8 9.79097 8 10.621C8 11.451 7.33 12.121 6.5 12.121Z" fill="black"/>-->
<!--          </svg>-->
<!--        </div>-->
      </div>

      <div *ngIf="signConfigClone.signatureImage.enabled" class="col-6 px-0">
        <mat-form-field style="line-height: 1.5; margin-top: 12px" class="w-100">
          <mat-label>{{"enterprise_contract.image_signing.no_image.signaturePosition" | translate}}</mat-label>
          <mat-select (selectionChange)="onCheckboxChange()" [(ngModel)]="signConfigClone.signaturePosition.value">
            <mat-option *ngFor="let position of signaturePosition" [value]="position.value">
              {{ position.name |translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="signConfigClone.signatureImage.enabled" class="col-6 pr-0">
        <mat-form-field style="line-height: 1.5; margin-top: 12px" class="w-100">
          <mat-label>{{"enterprise_contract.image_signing.no_image.signRatio" | translate}}</mat-label>
          <mat-select (selectionChange)="onCheckboxChange()" [(ngModel)]="signConfigClone.signatureRatio.value">
            <mat-option *ngFor="let ratio of signRatio" [value]="ratio.value">
              {{ ratio.name |translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #ConfigImageForm >
  <h5>{{"enterprise_contract.image_signing.no_image.create_signature" | translate}}</h5>
  <mat-divider></mat-divider>
  <div class=" ">
    <nz-tabset class="mt-3" [nzTabPosition]="'top'" [nzType]="'card'" [(nzSelectedIndex)]="indexSelect"
               (nzSelectChange)="nzSelectChange($event.index)">
      <!-- tab tải ảnh mới lên -->
      <nz-tab [nzTitle]="uploadImage" >
        <ng-template #uploadImage>{{
            "enterprise_contract.image_signing.new_tab.upload_signature"
              | translate
          }}
        </ng-template>
        <div class="tab-content">
          <div class="">
            <div class="clearfix nz-upload-clearfix d-flex justify-content-center">
              <button
                #btnUpload
                id="btnUpload"
                mat-raised-button
                class="mr-2"
                color="primary"
                type="button"
                (click)="inputUpload.click()"
                [ngClass]="{ active_document: false }"
              >
                <svg style="padding-right: 0.5rem" width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.6667 0.761081C9.70035 0.75431 7.79544 1.44589 6.29141 2.7126C4.78738 3.97931 3.78193 5.73887 3.45421 7.67775C2.32586 8.0486 1.36636 8.80902 0.747568 9.82284C0.128771 10.8367 -0.108915 12.0376 0.0770743 13.2107C0.263064 14.3838 0.860581 15.4524 1.76262 16.2251C2.66466 16.9978 3.81231 17.4241 5.00005 17.4277H11.6667C13.8769 17.4277 15.9965 16.5498 17.5593 14.987C19.1221 13.4242 20 11.3046 20 9.09441C20 6.88428 19.1221 4.76466 17.5593 3.20186C15.9965 1.63906 13.8769 0.761081 11.6667 0.761081ZM14.1309 11.3444C14.0985 11.4186 14.0453 11.4817 13.9777 11.5261C13.91 11.5705 13.8309 11.5942 13.75 11.5944H10.8334V14.0944C10.8334 14.3154 10.7456 14.5274 10.5893 14.6837C10.433 14.84 10.2211 14.9277 10 14.9277C9.77903 14.9277 9.56707 14.84 9.41079 14.6837C9.25451 14.5274 9.16671 14.3154 9.16671 14.0944V11.5944H6.25005C6.16956 11.5944 6.09079 11.5711 6.02327 11.5273C5.95575 11.4834 5.90238 11.421 5.86959 11.3475C5.8368 11.274 5.826 11.1925 5.83851 11.113C5.85101 11.0335 5.88628 10.9593 5.94005 10.8994L9.69005 6.73275C9.73017 6.69101 9.77831 6.6578 9.83158 6.63512C9.88485 6.61243 9.94215 6.60074 10 6.60074C10.0579 6.60074 10.1152 6.61243 10.1685 6.63512C10.2218 6.6578 10.2699 6.69101 10.31 6.73275L14.06 10.8994C14.1133 10.959 14.1482 11.0326 14.1608 11.1115C14.1734 11.1904 14.163 11.2713 14.1309 11.3444Z" fill="white"/>
                </svg>

                {{ "enterprise_contract.image_signing.no_image.upload_signature" | translate }}
              </button>
              <input
                type="file"
                #inputUpload
                id="file"
                [formControl]="nameImageSignatureControl"
                accept=".png,.jpg,.jpeg"
                class="form-control-file vt-input-form d-none mat-stroked-button-create-document"
                name="file"
                (change)="onSelectedUpload($event)"
                multiple
              />
            </div>
            <ng-container *ngIf="isSizeFileError">
              <div class="mt-2" style="color: #ee0033">{{'messages.image_must_than_2m' | translate}}</div>
            </ng-container>
            <ng-container *ngIf="isFormatFileError">
              <div class="mt-2" style="color: #ee0033">{{'messages.format_file_error' | translate}}</div>
            </ng-container>
            <ng-container *ngIf="!signConfigClone.isDraw.enabled && signConfigClone.signatureImageName.value">
              <div style="border-bottom: 1px solid gray; padding-bottom: 0.5rem;" class="mt-2 d-flex justify-content-between">
                <div [matTooltip]="signConfigClone.signatureImageName.value" style="color: #344054; font-weight: 500; width: 20rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{signConfigClone.signatureImageName.value}}</div>
                <em class="fa fa-trash fa-fw text-danger" style="cursor: pointer" (click)="deleteImageSignature()" matTooltip="{{'tooltips.delete' | translate}}"></em>
              </div>
            </ng-container>
          </div>
        </div>
      </nz-tab>

      <!-- tab vẽ chữ ký desktop -->
      <nz-tab [nzTitle]="drawSignature" (nzSelect)="onSelectDrawSign()">
        <ng-template #drawSignature>{{
            "enterprise_contract.image_signing.new_tab.draw_signature"
              | translate
          }}
        </ng-template>

        <div class="steps-content">
          <div class="tab-content d-flex justify-content-center">
            <!-- ảnh nhúng loại vẽ đã lưu -> fill lại vào ô vẽ để người dùng vẽ tiếp.
                 Giá trị set SAU khi canvas init (scheduleDrawCanvasRestore, gọi khi chọn tab Vẽ
                 hoặc dialog mở thẳng tab Vẽ) vì lần ngOnChanges đầu của canvas chạy trước khi
                 signaturePad sẵn sàng — giá trị set sẵn từ đầu sẽ bị guard bỏ qua -->
            <app-canvas (applySignatureImage)="applySignatureImage($event)" [isConfigSignDefault]="true" [canvasWidth]="canvasWidth" [canvasHeight]="canvasHeight"
                        [restoredImage]="drawCanvasRestoreImage"></app-canvas>
          </div>
        </div>
      </nz-tab>
    </nz-tabset>
  </div>
</ng-template>

<ng-template #ImageConfigView>
    <ng-container *ngIf="!signConfigClone?.signatureImage.enabled; else haveSignatureImage">
      <div [style.width]="'300px'" [style.height]="'136px'" class="image-config_view__content align-items-center d-flex flex-row" [style.justify-content]="transformContentPositionValue(signConfigClone.contentPosition.value)">
        <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
      </div>
    </ng-container>
  <ng-template #haveSignatureImage>
    <ng-container [ngSwitch]="signConfigClone?.signaturePosition?.value">
      <div *ngSwitchCase="'left'" [style.width]="'370px'" [style.height]="'136px'" class="image-config_view__content d-flex justify-content-center align-items-center flex-row">
        <div class="d-flex justify-content-center align-items-center" [style.flex] = "getNumber(signConfigClone.signatureRatio.value)[0]">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div style="padding-left: 6px;" class="d-flex align-items-center"
             [style.flex]="getNumber(signConfigClone.signatureRatio.value)[1]"
             [style.justify-content]="transformContentPositionValue(signConfigClone.contentPosition.value)">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
      <div *ngSwitchCase="'right'" [style.width]="'370px'" [style.height]="'136px'" class="image-config_view__content d-flex justify-content-center align-items-center flex-row-reverse">
        <div class="d-flex justify-content-center align-items-center" [style.flex] = "getNumber(signConfigClone.signatureRatio.value)[0]">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div style="padding-left: 6px;" class="d-flex align-items-center"
             [style.flex]="getNumber(signConfigClone.signatureRatio.value)[1]"
             [style.justify-content]="transformContentPositionValue(signConfigClone.contentPosition.value)">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
      <div *ngSwitchCase="'top'" [style.width]="'300px'" [style.height]="'237px'" class="image-config_view__content d-flex justify-content-center align-items-center flex-column">
        <div class="d-flex justify-content-center align-items-center" [style.height]="signConfigClone.signatureImage.enabled ? (+getNumber(signConfigClone.signatureRatio.value)[0] / 100) * 233 + 'px' : (+getNumber(signConfigClone.signatureRatio.value)[0] / 100) * 132 + 'px'">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div class="d-flex align-items-center"
             [style.height]="signConfigClone.signatureImage.enabled ? (+getNumber(signConfigClone.signatureRatio.value)[1] / 100) * 233 + 'px' : (+getNumber(signConfigClone.signatureRatio.value)[1] / 100) * 132 + 'px'"
             [style.justify-content]="transformContentPositionValue(signConfigClone.contentPosition.value)">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
      <div *ngSwitchCase="'bottom'" [style.width]="'300px'" [style.height]="'237px'" class="image-config_view__content d-flex justify-content-center align-items-center flex-column-reverse">
        <div class="d-flex justify-content-center align-items-center" [style.height]="signConfigClone.signatureImage.enabled ? (+getNumber(signConfigClone.signatureRatio.value)[0] / 100) * 233 + 'px' : (+getNumber(signConfigClone.signatureRatio.value)[0] / 100) * 132 + 'px'">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div class="d-flex align-items-center"
             [style.height]="signConfigClone.signatureImage.enabled ? (+getNumber(signConfigClone.signatureRatio.value)[1] / 100) * 233 + 'px' : (+getNumber(signConfigClone.signatureRatio.value)[1] / 100) * 132 + 'px'"
             [style.justify-content]="transformContentPositionValue(signConfigClone.contentPosition.value)">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #SignatureViewContent>
  <ng-container *ngIf="signConfigClone && signConfigClone.signatureImageBase64 && signConfigClone.signatureImageBase64.value && signConfigClone.signatureImageBase64.value.split(',')[1]">
    <ng-container *ngIf="signConfigClone?.signaturePosition?.value === 'left' || signConfigClone?.signaturePosition?.value === 'right'">
      <img [style.max-height]="'127px'" [style.max-width]="361 * (+getNumber(signConfigClone.signatureRatio.value)[0] / 100) + 'px'"  [src]="signConfigClone.signatureImageBase64.value">
    </ng-container>
    <ng-container *ngIf="signConfigClone?.signaturePosition?.value === 'top' || signConfigClone?.signaturePosition?.value === 'bottom'">
      <img [style.max-width]="'291px'" [style.max-height]="228 * (+getNumber(signConfigClone.signatureRatio.value)[0] / 100) + 'px'" [src]="signConfigClone.signatureImageBase64.value">
    </ng-container>
  </ng-container>
</ng-template>
<ng-template #ImageViewContent>
  <div id="image-config_form_preview" class="image-config_form_preview" [style.max-height]="signConfigClone?.signaturePosition?.value === 'top' || signConfigClone?.signaturePosition?.value === 'bottom' ? 233 * (+getNumber(signConfigClone.signatureRatio.value)[1] / 100) + 'px' : 'auto'">
    <ng-container *ngFor="let key of getConfigKeyList()">
      <ng-container *ngTemplateOutlet="ConfigViewItem; context: {$implicit: key}"></ng-container>
    </ng-container>

    <ng-container *ngIf="signConfigClone.greenTick.enabled">
      <div class="green-tick w-100"
           [style.justify-content]="transformContentPositionValue(signConfigClone.contentPosition.value)"
           [style.top]="signConfigClone.signaturePosition.value ? 18 * (+getNumber(signConfigClone.signatureRatio.value)[1] / 100) + 'px' : '18px'"
      >
<!--        [style.left]="signConfigClone.signaturePosition.value ? 46 * (+getNumber(signConfigClone.signatureRatio.value)[1] / 100) + 'px' : '46px'"-->
        <svg width="79" height="58" viewBox="0 0 79 58" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M77.2308 2.10253C78.9231 3.7948 78.9231 6.53852 77.2308 8.23079L29.5641 55.8975C27.8719 57.5897 25.1281 57.5897 23.4359 55.8975L1.7692 34.2308C0.0769319 32.5385 0.0769319 29.7948 1.7692 28.1025C3.46148 26.4103 6.20519 26.4103 7.89746 28.1025L26.5 46.7051L71.1025 2.10253C72.7948 0.41026 75.5385 0.41026 77.2308 2.10253Z" fill="#52C41A"/>
        </svg>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #ConfigViewItem let-data>
    <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" *ngIf="showConfig(data)" class="view-content-item" [style.justify-content]="transformContentPositionValue(signConfigClone.contentPosition.value)">
      <ng-container *ngIf="data == 'signatureImage' || data == 'isDraw'; else displayColon"></ng-container>
      <ng-template #displayColon>
        <div style="word-break: break-word;" [style.textAlign]="signConfigClone.contentPosition.value">
          {{signConfigClone[data].label | translate}}: {{signConfigClone[data].value}}
        </div>
      </ng-template>

<!--        <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" class="label"></div>&nbsp;-->

<!--      <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" align="start" style="word-break: break-word; white-space: pre-wrap;">-->
<!--        <ng-container>-->
<!--          {{signConfigClone[data].value}}-->
<!--        </ng-container>-->
<!--      </div>-->
    </div>
</ng-template>
